export const BROCHUREWARE_URL = 'https://uk.virginmoney.com/service/sign-in/personal-loans',
  EXPERIAN_URL = 'https://www.experian.co.uk/?external=true#use',
  CALL_CREDIT_URL = 'https://www.transunion.co.uk/?external=true#use',
  FREEDOM_FINANCE_URL = 'https://online.freedomfinance.co.uk/?advsrcSuggest=CLYDW&source=CLYDW',
  UPLOAD_DOCUMENTS_URL = ' https://uk.virginmoney.com/service/upload-your-documents/?external=true',
  NATIVE_ACCOUNTS_URL = 'http://native/exit/accounts',
  CHECK_ELIGIBILITY_URL =
    'https://uk.virginmoney.com/personal-loans/check-your-eligibility?external=true';
